var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-controller',{attrs:{"linkSubject":_vm.linkSubject,"thread-id":_vm.threadId},on:{"success":_vm.setSuccess},scopedSlots:_vm._u([{key:"tip-view",fn:function(ref){
var processing = ref.processing;
var value = ref.value;
var currencySymbol = ref.currencySymbol;
var showPaidError = ref.showPaidError;
var onInput = ref.onInput;
var onSubmit = ref.onSubmit;
var reset = ref.reset;
return [_c('tipping-view',{attrs:{"show":_vm.show && !showPaidError,"currency-symbol":currencySymbol,"processing":processing,"value":value,"success":_vm.success},on:{"submit":onSubmit,"input":onInput,"close":function () {
        reset();
        _vm.close();
      }}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }